import { useTranslation } from 'react-i18next';
import { Icon } from '@/components/common/Icon';
import { Button } from '@/components/ui/button';
import { useAuth } from '@/hooks/useAuth';

export function AccessErrorScreen() {
  const { t } = useTranslation('common');
  const { logOut } = useAuth();

  return (
    <div className="min-h-screen flex items-center justify-center bg-zoooffwhite p-4">
      <div className="w-full max-w-md bg-zoowhite border border-zooborder rounded-3xl shadow-xl p-8 text-center">
        <div className="w-14 h-14 rounded-2xl bg-zooerrorbg flex items-center justify-center mx-auto mb-4">
          <Icon name="Lock" className="text-xl text-zooerrortext" />
        </div>
        <h1 className="text-xl font-bold text-zooindigo">{t('accessError.title')}</h1>
        <p className="text-sm text-zoomuted mt-2">{t('accessError.description')}</p>
        <Button
          onClick={function handleLogout() {
            logOut();
          }}
          className="mt-6 w-full"
        >
          {t('actions.logout')}
        </Button>
      </div>
    </div>
  );
}
